const csrfElement = document.head.querySelector('meta[name="csrf-token"][content]');

export default {
    csrfToken: csrfElement instanceof HTMLMetaElement ? csrfElement.content : null,

    sentry: {
        dsn: 'https://cb0a42dc86f54027bc44d45d7a8f0a52@sentry.mycrhnet.com/19',
    },
};
